import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import OptionList from "../components/products/options/optionList";
import AddEditOption from "../components/products/options/addEditOption";
import SortOptionList from "../components/products/options/sortOptionList";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const OptionStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"OptionList"}
            screenOptions={{ headerShown: false, animationEnabled: false }}>
            <AppStack.Screen name="OptionList" component={OptionList} />
            <AppStack.Screen name="AddEditOption" component={AddEditOption} />
            <AppStack.Screen name="SortOptionList" component={SortOptionList} />

        </AppStack.Navigator>
    );
};

export default OptionStack;